import { render } from "./bundleDetailCard.vue?vue&type=template&id=962dfcf0"
import script from "./bundleDetailCard.vue?vue&type=script&lang=js"
export * from "./bundleDetailCard.vue?vue&type=script&lang=js"

import "./bundleDetailCard.vue?vue&type=style&index=0&id=962dfcf0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__